import { requestManager } from '../../requestManager';
import Confirmation from './confirmation';

import { API_PATH } from '../../config/config';

class CustomReserveConfirmation extends Confirmation.Constructor {
  /**
   * 受付登録(カスタマイズ)
   * @param {string} lgCd 市町村コード
   * @param {object} customReceptInfo 受付情報
   * @param {Array} business 用件
   * @param {Array} recItems 申請項目
   * @param {object} reserveInfo 予約情報
   * @param {string} userCd 利用者コード
   * @param {number} rsvSetId 予約設定ID
   * @param {object} place 予約施設情報
   * @param {boolean} useHome 自宅を使用するかどうか
   * @param {number} rsvFlag 予約フラグ
   * @param {string} baseName 代替氏名
   * @return {Promise<Boolean>} 登録成否
   */
  customRegisterReception = async (
    lgCd,
    customReceptInfo,
    business,
    recItems,
    reserveInfo,
    userCd,
    rsvSetId,
    place,
    useHome,
    rsvFlag,
    baseName,
    formSetId
  ) => {
    const result = await requestManager.post(`${API_PATH}/customformconfirmation/c/`, {
      lgCd,
      customReceptInfo,
      business,
      recItems,
      reserveInfo,
      userCd,
      rsvSetId,
      place,
      useHome,
      rsvFlag,
      baseName,
      formSetId,
    });
    return result.data;
  };
}

export default new CustomReserveConfirmation();
